import React from 'react';
import {HighlightedTextProps} from './HighlightedText.props';
import './HighlightedText.styles.css';
import Box from "@mui/material/Box";
import {highlightedText} from "../../../utils/common";
import {Tooltip} from "@mui/material";

export const HighlightedText: React.FC<HighlightedTextProps> = ({
  type,
  isUsedTooltip = false,
  tooltipDescription = "",
  tooltipStyle = {}
}) => {
  const highlightedComponent = <Box className={`highlighted_text_status highlighted_text_type_${type}`}>
    <span>{highlightedText(type)}</span>
  </Box>

  if (!isUsedTooltip) return highlightedComponent

  return <Tooltip placement={"top"} title={tooltipDescription}
           componentsProps={{
             tooltip: {
               sx: tooltipStyle,
             },
           }}
  >
    {highlightedComponent}
  </Tooltip>
};
